import { QueryTuple, useLazyQuery } from '@apollo/client';
import { UserAccount } from '@bechtel/sr-types';
import { useEffect } from 'react';
import { EMULATED_USER_ID, USER_PROJECT_ID, useAppUserUpdater } from '~/components';
import { GET_USER_ACCOUNT_BY_AUTH } from '~/gql';
import { useEnvProvider } from '~/hooks';

export function useAuthorizeUser(): QueryTuple<{ userAccountByAuth: UserAccount }, Record<string, any>> {
  const { envConfig } = useEnvProvider();
  const response = useLazyQuery<{ userAccountByAuth: UserAccount }>(GET_USER_ACCOUNT_BY_AUTH, {
    notifyOnNetworkStatusChange: true,
    //TODO: Not needed to authorise every route change. Use real time notifications to invalidate permissions
    //if the user permissions change
  });
  const { data } = response[1];
  const { userAuthorized, userNotAuthorized } = useAppUserUpdater();

  useEffect(() => {
    const user: UserAccount | undefined = data ? data.userAccountByAuth : undefined;
    if (user) {
      userAuthorized({ ...user });
      if (user.defaultProject) {
        window.sessionStorage.setItem(USER_PROJECT_ID, user.defaultProject.id);
      }
    } else {
      userNotAuthorized();
    }
  }, [data, userAuthorized, userNotAuthorized]);

  useEffect(() => {
    const user: UserAccount | undefined = data ? data.userAccountByAuth : undefined;
    if ((envConfig && envConfig.enableEmulation && envConfig.enableEmulation.toLowerCase() !== 'true') || !user) return;
    const emulatedUserId = window.sessionStorage.getItem(EMULATED_USER_ID) || '';
    // If emulation fails, the logged in user will be returned. Set the emulateduservalue to '' for logged in user
    if (user.loginName !== emulatedUserId) window.sessionStorage.setItem(EMULATED_USER_ID, '');
  }, [data, envConfig]);

  return response;
}
